import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logScreenView } from '../../utils/tracker';
import { ROUTE_PATHS } from '@/constants/routePaths';

/**
 * 路由级自动页面埋点:pathname 变化时上报一次,不渲染任何内容。
 * 挂在 routers.js 的 Suspense 内 —— 懒加载 chunk 就绪后才挂载,避免页面还在 loading 就上报"进入"。
 */

// 路由 → 埋点页面名(logScreenView 的入参)。新增路由时在这里补一行,名字以埋点需求文档为准。
const SCREEN_NAMES = {
  [ROUTE_PATHS.SERVICE]: 'h5_subscribe_self',
  [ROUTE_PATHS.PLAN]: 'h5_subscribe_center',
  [ROUTE_PATHS.DIFF]: 'h5_subscribe_diff',
  [ROUTE_PATHS.SIM]: 'h5_sim_home',
  [ROUTE_PATHS.ERROR]: 'h5_error',
};

// 未匹配的路径走兜底路由(ROUTE_PATHS.FALLBACK),统一按通用页面名上报
const DEFAULT_SCREEN_NAME = 'h5_default_page';

const RouteTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    logScreenView(SCREEN_NAMES[pathname] || DEFAULT_SCREEN_NAME);
  }, [pathname]);

  return null;
};

export default RouteTracker;
